import script from "./admin-dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-dashboard.vue?vue&type=script&setup=true&lang=js"

import "./admin-dashboard.vue?vue&type=style&index=0&id=7fcbfe8e&lang=css"

const __exports__ = script;

export default __exports__